import { useContext } from "react";
import { AppContext } from "../../../app/AppContext.tsx";

export const useDeepResearchService = () => {
  const { deepResearchService } = useContext(AppContext);
  if (!deepResearchService)
    throw new Error("DeepResearchService not initialized");
  return deepResearchService;
};
